import type { ReactElement } from "react";

export function DocumentIcon(): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
    >
      <path
        d="M8.125 17.9H15.9V16.4H8.125V17.9ZM8.125 13.65H15.875V12.15H8.125V13.65ZM6.5155 21.8C5.87633 21.8 5.339 21.5822 4.9035 21.1465C4.46783 20.711 4.25 20.1737 4.25 19.5345V4.46551C4.25 3.82635 4.46783 3.28901 4.9035 2.85351C5.339 2.41785 5.87633 2.20001 6.5155 2.20001H14.2L19.75 7.72501V19.5345C19.75 20.1737 19.5322 20.711 19.0965 21.1465C18.661 21.5822 18.1237 21.8 17.4845 21.8H6.5155ZM13.4 8.55001H18.1L13.4 3.85001V8.55001Z"
        fill="#9600F1"
      />
    </svg>
  );
}
